import selectCollection from "./collection"

export default function selectError(state, engine, model, query) {
  const collection = selectCollection(state, engine, model, query)
  return collection ? collection.error : null
}
